module.exports = __webpack_public_path__ + "static/media/RobotoMono-Regular.5b04fdfe.ttf";